/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Vast_Pike_NodInputs */

const en_safe_vast_pike_nod = /** @type {(inputs: Safe_Vast_Pike_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No errors`)
};

const de_safe_vast_pike_nod = /** @type {(inputs: Safe_Vast_Pike_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Fehler`)
};

/**
* | output |
* | --- |
* | "No errors" |
*
* @param {Safe_Vast_Pike_NodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const safe_vast_pike_nod = /** @type {((inputs?: Safe_Vast_Pike_NodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Vast_Pike_NodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_safe_vast_pike_nod(inputs)
	return de_safe_vast_pike_nod(inputs)
});